export enum SimpleDatesUserDetailsKey {
  BodyType = 'body_type',
  Drink = 'drink',
  Education = 'education',
  Ethnicity = 'ethnicity',
  HaveKids = 'have_kids',
  Height = 'height',
  Interests = 'interests',
  Languages = 'languages',
  LookingFor = 'looking_for',
  MaritalStatus = 'marital_status',
  PreferenceTags = 'preference_tags',
  Religion = 'religion',
  Smoking = 'smoking',
  Weight = 'weight',
  AboutMe = 'about_me',
  StarSign = 'star_sign',
  WantChildren = 'want_children',
  Occupation = 'occupation',
  Additional = 'additional',
  ShownDistance = 'shown_distance',
}
